module.exports = __webpack_public_path__ + "assets/img/zs-1.21a5cf9c.jpg";